<template>
  <div class="filters card">
    <div class="card-header d-flex justify-content-between align-items-center">
      {{$t('category.activeFilters')}}
      <i class="icon icon-arrow-down"></i>
    </div>
    <ul class="list-group list-group-flush">
      <li
        v-for="item in active"
        :key="`${item.type}-${item.id}`"
        class="list-group-item d-flex justify-content-between align-items-center">
        {{ item.title }}
        <span class="badge" @click="remove(item)"><i class="icon icon-close"></i></span>
      </li>
      <li v-if="active.length === 0"
        class="list-group-item d-flex justify-content-between align-items-center">
        {{$t('category.noFilters')}}
      </li>
    </ul>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('filters')

export default {

  computed: mapGetters(['active']),

  methods: {
    ...mapActions(['deselect']),

    remove (item) {
      this.deselect({ type: item.type, item })
    }
  }

}
</script>
